import i18n from '../../i18n'
import {
  CHECKOUT_ROUTE,
  REVIEW_AND_COMPLETE_ROUTE,
  CATALOG_ROUTE,
  ERROR_ROUTE,
  REDEMPTION_HISTORY_ROUTE,
  ORDER_COMPLETE_ROUTE
} from './route-names'
import DigitalRewardLinkView from '../../views/ExistingRewardLinkView'
import CatalogView from '../../components/reward/CatalogView'
import ItemLayout from '../../components/cart/ItemLayout'
import RewardDetailView from '../../components/reward/RewardDetailView'
import Checkout from '../../components/checkout/Checkout'
import CompletedOrder from '../../components/checkout/CompletedOrder'
import ReviewAndComplete from '../../components/checkout/ReviewAndComplete'
import FAQ from '../../components/footer/FAQ'
import ContactUs from '../../components/footer/ContactUs'
import TermsOfService from '../../components/footer/TermsOfService'
import RedemptionHistory from '@/components/history/RedemptionHistory'
import { getExistingRouteNameEquivalent } from './utilities'
import { directPaymentRoutes } from './direct-payments'
import { StaticRewardLinkService } from '@/service/order_info/StaticRewardLinkService'
import ServiceRegistry from '@/service/registry/ServiceRegistry'

const ROUTE_IS_ACTIVE_FOR_EXPIRED_AND_REDEEMED_REWARDS =
  'routeIsActiveForExpiredAndRedeemedRewards'

const existingRewardLinkRoutes = [
  {
    path: '/r/:urlVersion',
    component: DigitalRewardLinkView,
    meta: {
      h1: i18n.t('catalog-title-default'),
      h2: '',
      h2Hidden: false
    },
    children: [
      {
        path: '',
        name: CATALOG_ROUTE,
        component: CatalogView,
        meta: {
          h1: i18n.t('catalog-title-default'),
          h2: '',
          h2Hidden: false,
          segmentName: 'Catalog'
        }
      },
      {
        path: 'cart',
        name: 'Cart',
        component: ItemLayout,
        meta: {
          h1: i18n.t('checkout-cart-title'),
          h2: '',
          h2Hidden: false,
          segmentName: 'Cart'
        }
      },
      {
        path: 'reward/:brandKey',
        name: 'Reward',
        component: RewardDetailView,
        meta: {
          h1: '',
          h2: '',
          h2Hidden: false,
          segmentName: 'Reward Details'
        },
        props: true
      },
      {
        path: 'checkout',
        name: CHECKOUT_ROUTE,
        component: Checkout,
        meta: {
          h1: i18n.t('checkout-title'),
          h2: i18n.t('checkout-title-detail'),
          h2Hidden: false,
          segmentName: 'Checkout'
        }
      },
      {
        path: 'checkout/review-and-complete',
        name: REVIEW_AND_COMPLETE_ROUTE,
        component: ReviewAndComplete,
        meta: {
          h1: i18n.t('review-and-complete-title'),
          h2: i18n.t('review-and-complete-subtitle'),
          h2Hidden: false,
          segmentName: 'Review And Complete'
        }
      },
      {
        path: 'complete/:refOrderId',
        name: ORDER_COMPLETE_ROUTE,
        component: CompletedOrder,
        meta: {
          h1: '',
          h2: '',
          h2Hidden: false,
          segmentName: 'Completed Order Summary',
          [ROUTE_IS_ACTIVE_FOR_EXPIRED_AND_REDEEMED_REWARDS]: true
        }
      },
      {
        path: 'redemption-history',
        name: REDEMPTION_HISTORY_ROUTE,
        component: RedemptionHistory,
        meta: {
          h1: i18n.t('redemption-history-title'),
          h2: '',
          h2Hidden: true,
          segmentName: 'Redemption History',
          [ROUTE_IS_ACTIVE_FOR_EXPIRED_AND_REDEEMED_REWARDS]: true
        }
      },
      {
        // Redirect to external knowledge base in case of bookmark, manual url entry, etc.
        beforeEnter () {
          window.location = process.env.VUE_APP_KNOWLEDGE_BASE_URL
        },
        path: 'faq',
        name: getExistingRouteNameEquivalent({ name: 'FAQ' }),
        component: FAQ,
        meta: {
          h1: i18n.t('faq-title'),
          h2: i18n.t('faq-subtitle'),
          h2Hidden: false,
          segmentName: 'Frequently Asked Questions'
        }
      },
      {
        // Redirect to external knowledge base in case of bookmark, manual url entry, etc.
        beforeEnter () {
          window.location = process.env.VUE_APP_KNOWLEDGE_BASE_URL
        },
        path: 'contact-us',
        name: getExistingRouteNameEquivalent({ name: 'ContactUs' }),
        component: ContactUs,
        meta: {
          h1: i18n.t('contact-us-title'),
          h2: '',
          h2Hidden: true,
          segmentName: 'Contact Us',
          [ROUTE_IS_ACTIVE_FOR_EXPIRED_AND_REDEEMED_REWARDS]: true
        }
      },
      {
        path: 'terms-of-service',
        name: getExistingRouteNameEquivalent({ name: 'TermsOfService' }),
        component: TermsOfService,
        meta: {
          h1: i18n.t('terms-of-service-title'),
          h2: '',
          h2Hidden: true,
          segmentName: 'Terms of Service',
          [ROUTE_IS_ACTIVE_FOR_EXPIRED_AND_REDEEMED_REWARDS]: true
        }
      },
      ...directPaymentRoutes
    ]
  }
]

// Request code path must be last child route,
// otherwise could match sibling routes defined below it & get triggered.
existingRewardLinkRoutes[0].children.push({
  path: ':requestCode',
  async beforeEnter (to, from, next) {
    try {
      const sessionStorageService = ServiceRegistry.inject(StaticRewardLinkService)
      await sessionStorageService.init(to.params.requestCode, to.params.urlVersion, to.query.isPrintable)
    } catch (e) {
      next({
        name: ERROR_ROUTE,
        params: {
          errorTitle: i18n.t('error-invalid-link-title'),
          errorBody: i18n.t('error-invalid-link-body'),
          allowNavigation: true
        }
      })
    }
    next({ name: CATALOG_ROUTE, params: { urlVersion: to.params.urlVersion } })
  }
})

export {
  existingRewardLinkRoutes,
  ROUTE_IS_ACTIVE_FOR_EXPIRED_AND_REDEEMED_REWARDS
}
